import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import ManageCompanies from "./pages/ManageCompanies";
import Navbar from "./components/Navbar";
import "./App.css";
import ExploreCompanies from "./pages/ExploreCompanies";
import FeaturesAndProcess from "./pages/features_process";
import Blogs from "./pages/Blogs";
import CreateBlog from "./pages/CreateBlog";
import BlogDetail from "./pages/BlogDetail";
import AboutPage from "./pages/about";
import Video from "./pages/video";
import CompanyDetails from "./pages/CompanyDetails";
import Login from "./components/Login";
import NewsletterSignup from "./pages/newsletter";

import Terms from "./pages/Terms";
import RefundPolicy from "./pages/Refund";
import PrivacyPolicy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";
import CompanyHighlights from "./pages/CompanyHighlights";
import CompanyDetailPage from "./pages/CompanyDetailPage";
import ChatWidget from "./components/ChatWidget";



// Use in your routing

// ✅ Admin route protection wrapper
const AdminRoute = ({ element }) => {
  const role = localStorage.getItem("role");
  return role === "admin" ? element : <Navigate to="/login" replace />;
};

// ✅ Wrapper to handle Navbar visibility
const AppContent = () => {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login"; // hide only on login
  const hideChat = location.pathname === "/login";   // optional


  return (
    <>
      {!hideNavbar && <Navbar />}

      {/* 🔥 ChatWidget on all pages */}
      {!hideChat && <ChatWidget />}
      {/* 👈 hide Navbar on /login */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<ExploreCompanies />} />
        {/* <Route path="/company/:id" element={<CompanyDetails />} /> */}
        <Route path="/company/:id/:slug" element={<CompanyDetailPage />} />

        <Route path="/FeaturesAndProcess" element={<FeaturesAndProcess />} />
        <Route path="/Blogs" element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/videos" element={<Video />} />
        <Route path="/company-details" element={<CompanyDetails />} />
        <Route path="/newsletter" element={<NewsletterSignup />} />

        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/terms-condition" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-refund-policy" element={<RefundPolicy />} />
        <Route path="/CompanyHighlights" element={<CompanyHighlights />} />



        {/* ✅ Admin-only protected routes */}
        <Route
          path="/manage"
          element={<AdminRoute element={<ManageCompanies />} />}
        />
        <Route
          path="/create_blog"
          element={<AdminRoute element={<CreateBlog />} />}
        />

        {/* ✅ Login route (no navbar) */}
        <Route path="/login" element={<Login />} />

        {/* ✅ Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
